import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Button, Grid, Menu, TextareaAutosize, Typography } from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { editWordRequest } from '@redux/Language/actions';

export interface IModalEditLanguageProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  initValue: any;
  handleEdit : any;
  searchText: any
}

const schema = yup.object({
  content: yup.string(),
});

export default function ModalEditLanguage (props: IModalEditLanguageProps) {
  const { initValue, anchorEl, open, handleClose, handleEdit, searchText } = props;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [content, setContent] = React.useState<string>("");
  const [pathName, setPathName] = React.useState<string>("");
  // const [openToast, setOpenToast] = React.useState(false);
  const dispatch = useDispatch()
  React.useEffect(() => {
    if (initValue) {
      setValue("content", initValue?.data[initValue?.keyLang]);
      setPathName(initValue.pathLang)
    }
  }, [initValue])

  const handleCloseModal = () => {
    handleClose()
  }

  const onSubmit = async(data: any) => {
    const bodyRequest = {
      word: initValue.wordId,
      lang: initValue.keyLang,
      content: content ===""? initValue.payload: content,
      searchText: initValue.searchText
    }
    // console.log(bodyRequest)
    dispatch(editWordRequest(bodyRequest));
    handleCloseModal();
  }

  return (
    <>
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      sx={{ mt: 3, mr: 2 }}>
    {/* > &#8288; */}
      <form onSubmit={handleSubmit(onSubmit)} id="my-form">
        <Grid
          container
          alignItems={"center"}
          sx={{ p: 2, width: '100%', marginTop: 2, minWidth: '275px' }}
        >
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 3 }}>
            <Typography variant='h6' component={'h2'} sx={{ mb: 1 }}>Nhập ngôn ngữ</Typography>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 1 }}>
            <div style={{ width: "95%" }}       
              onKeyDown={e => e.stopPropagation()}>
              <Controller
                name="content"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextareaAutosize
                    placeholder="Nhập ngôn ngữ"
                    defaultValue={initValue.payload}
                    onChange={(e) => {
                      setContent(e.target.value);
                    }}
                    style={{ width: 'inherit', padding: '10px', margin: '0 10px', resize: 'none', fontFamily: '"Roboto", sans-serif' }}
                  />
                )}
              />
              
            </div>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 3 }} direction="row">
            <Typography variant='h6'>Path name:</Typography>&nbsp;&nbsp;<Typography>{pathName}</Typography>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} justifyContent={'flex-end'} wrap={'nowrap'} sx={{ mt: 5 }}>
            <Button variant='contained' color='secondary' sx={{ mr: 1 }} onClick={handleCloseModal}>Hủy</Button>
            <Button variant='contained' color='primary' type='submit'>Lưu</Button>
          </Grid>
        </Grid>
      </form>
    </Menu>
    </>
  );
}
